import React, { Component } from 'react';

import DurationToggle from '../DurationToggle/DurationToggle';
import LanguageFilter from '../LanguageFilter/LanguageFilter';
import TimeSlider from '../TimeSlider/TimeSlider';

import './FilterSidebar.css';

class FilterSidebar extends Component {
  render() {
    return (
      <div className="FilterSidebar d-flex flex-column">
        <div id="filter-sidebar" className="collapse filter-collapse">
          <div id="filter-options" className="d-flex flex-column justify-content-around">
            <div id="filter-accordion" className="row no-gutters">
              <div id="accordion" className="col" role="tablist" aria-multiselectable="true">
                <LanguageFilter />
              </div>
            </div>

            <TimeSlider />
            <DurationToggle />
          </div>
        </div>

        <div className="filter-toggleable hidden-md-up bg-inverse">
          <button
            className="btn btn-outline-primary btn-sm btn-block"
            type="button"
            data-toggle="collapse"
            data-target="#filter-sidebar"
            aria-expanded="true"
            aria-controls="filter-sidebar"
            aria-label="Booking filters"
          >
            Filters
          </button>
        </div>
      </div>
    );
  }
}

export default FilterSidebar;



// WEBPACK FOOTER //
// ./src/components/filters/FilterSidebar/FilterSidebar.js